import firebase, { firebaseRemoteConfig } from './firebase';

export { firebaseRemoteConfig };
export default firebase;
